var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLifeIdSaturation(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "BoxContent/Header/LeftIcon42") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "BoxContent/Header/LeftIcon42",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "BoxContent/Header/LeftIcon",
    fill: "#F5F5F7",
    opacity: 0
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-12",
    transform: "translate(2.000000, 3.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Combined-Shape-3",
    transform: "translate(0.000000, 1.000000)",
    fill: "#181E34",
    opacity: 0.400000006
  }, /*#__PURE__*/React.createElement("g", {
    id: "Combined-Shape-2",
    transform: "translate(0.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(-0.000371, -0.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.50037053,3 C10.85071,3 12.9096916,4.24745134 14.0513438,6.11638255 C13.0650261,5.51361395 11.9065486,5.16666667 10.6670372,5.16666667 C7.07718632,5.16666667 4.1670372,8.07681579 4.1670372,11.6666667 C4.1670372,12.9061781 4.51398448,14.0646556 5.11606389,15.0502841 C3.24782187,13.909321 2.00037053,11.8503395 2.00037053,9.5 C2.00037053,5.91014913 4.91051966,3 8.50037053,3 Z",
    id: "Combined-Shape",
    transform: "translate(8.025857, 9.025142) rotate(-15.000000) translate(-8.025857, -9.025142) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5,2.0006065 C14.8503395,2.0006065 16.909321,3.24805784 18.0509733,5.11698905 C17.0646556,4.51422045 15.9061781,4.16727317 14.6666667,4.16727317 C11.0768158,4.16727317 8.16666667,7.07742229 8.16666667,10.6672732 C8.16666667,11.9067846 8.51361395,13.0652621 9.11569336,14.0508906 C7.24745134,12.9099275 6,10.850946 6,8.5006065 C6,4.91075563 8.91014913,2.0006065 12.5,2.0006065 Z",
    id: "Combined-Shape-Copy",
    transform: "translate(12.025487, 8.025749) rotate(-195.000000) translate(-12.025487, -8.025749) "
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Combined-Shape-Copy-3",
    transform: "translate(3.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Combined-Shape-Copy-2",
    transform: "translate(-0.000000, 0.000000)"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLifeIdSaturation);
export default __webpack_public_path__ + "static/media/life_id-saturation.2e71ac28255822ef77fa9f272e978cf3.svg";
export { ForwardRef as ReactComponent };